@switch (styleSg()) {
  @case (StyleEnum.Error) {
    <i
      [atnDsTooltip]="descriptionSg()"
      class="atn-icon default atn-error"
    ></i>
  }
  @case (StyleEnum.Info) {
    <i
      [atnDsTooltip]="descriptionSg()"
      class="atn-icon default atn-information atn-blue"
    ></i>
  }
  @case (StyleEnum.Success) {
    <i
      [atnDsTooltip]="descriptionSg()"
      class="atn-icon default atn-done atn-with-circle"
    ></i>
  }
  @case (StyleEnum.Warning) {
    <i
      [atnDsTooltip]="descriptionSg()"
      class="atn-icon default atn-warning-triangle"
    ></i>
  }
}
